"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const formik_1 = require("formik");
const react_2 = require("react");
const yup = __importStar(require("yup"));
const DispatchContext_1 = require("../context/DispatchContext");
const Button_1 = __importDefault(require("../elements/Button"));
const CloseButton_1 = __importDefault(require("../elements/CloseButton"));
const FormikTextarea_1 = __importDefault(require("../elements/formik/FormikTextarea"));
const Alert_1 = require("../elements/popup/Alert");
const ModalStyle_1 = require("./ModalStyle");
const styles = (0, react_1.css) `
  width: 600px;
  height: 300px;

  .inner-content {
    flex: 1;
    border: none;
    overflow: hidden;
    padding: 0;
  }

  .text-area {
    width: 100%;
    height: 100%;
    outline: none;
    resize: none;
    padding: 0 0 0 15px;
  }
`;
const validationSchema = yup.object({
    publicationText: yup.string().required(),
});
function ImportPublicationStringModal({ onClose, }) {
    const formRef = (0, react_2.useRef)();
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const alert = (0, Alert_1.useAlert)();
    const publicationStringHandler = (0, react_2.useCallback)((values) => {
        void (async () => {
            const hideLoading = await alert.showLoading('Generate spectrum from publication string in progress');
            setTimeout(() => {
                dispatch({
                    type: 'GENERATE_SPECTRUM_FROM_PUBLICATION_STRING',
                    payload: values,
                });
                hideLoading();
            });
            onClose();
        })();
    }, [alert, dispatch, onClose]);
    return ((0, jsx_runtime_1.jsxs)("div", { css: [ModalStyle_1.ModalStyles, styles], children: [(0, jsx_runtime_1.jsxs)("div", { className: "header handle", children: [(0, jsx_runtime_1.jsx)("span", { children: "Import from publication string" }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClick: onClose, className: "close-bt" })] }), (0, jsx_runtime_1.jsx)("div", { className: "inner-content", children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: formRef, initialValues: {
                        publicationText: '1H NMR (CDCl3, 400MHz) δ 10.58 (b, 1H), 7.40 (d, 1H, J = 8.0 Hz), 6.19 (d, 1H, J = 7.6 Hz), 4.88 (s, 1H), 2.17 (s, 3H), 1.02 (s, 9H), 1.01 (s, 9H), 0.89 (s, 9H)',
                    }, validationSchema: validationSchema, onSubmit: publicationStringHandler, children: (0, jsx_runtime_1.jsx)(FormikTextarea_1.default, { name: "publicationText", className: "text-area", placeholder: "Enter publication string" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "footer-container", children: (0, jsx_runtime_1.jsx)(Button_1.default.Done, { onClick: () => formRef.current.submitForm(), children: "Import" }) })] }));
}
exports.default = ImportPublicationStringModal;
